import React, { Component } from 'react'
import { pick } from 'lodash'
import Reports from '../../../components/Finance/Reports/Reports'
import ReportsApi from '../../../api/Finance/Reports'
import InvoicesAPI from '../../../api/Sales/Invoices'
import { message } from 'antd'

class ReportsCont extends Component {
  state = {
    invoices: [],
    visible: false,
  }
  invoicesFormRef = React.createRef()
  api = new ReportsApi()
  invoicesApi = new InvoicesAPI()

  fetchInvoices = async (values) => {
    const filter = {
      company: values.company,
      client: values.client,
      dates: {
        start: values.date[0],
        end: values.date[1],
      },
    }

    try {
      this.setState({
        fetchingInvoices: true,
      })
      const invoices = await this.invoicesApi.listByFilter(filter)
      this.setState({
        fetchingInvoices: false,
        invoices,
      })
      return invoices
    } catch (e) {
      this.setState({
        fetchingInvoices: false,
      })
      message.error(e.errorMessage)
    }
  }
  filterInvoice = () => {
    this.invoicesFormRef.current.validateFields(async (err, values) => {
      if (!err) {
        this.fetchInvoices(values)
      }
    })
  }

  onShow = () => {
    this.setState({
      visible: true,
    })
  }
  onCancel = () => {
    this.setState({
      visible: false,
    })
  }

  render() {
    return (
      <Reports
        {...this.state}
        {...pick(this, ['fetchInvoices', 'filterInvoice', 'invoicesFormRef', 'onShow', 'onCancel'])}
      />
    )
  }
}

ReportsCont.propTypes = {}
ReportsCont.defaultProps = {}

export default ReportsCont
